import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { ROLE_PUBLIC } from '@router/Routes'
import { useTranslation } from 'react-i18next'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'
import useHtmlRenderer from '@hook/useHtmlRenderer'

const Home = () => {
  const { mission, homePage } = useSelector(state => state.main)
  const { isCompany, isCoOwnership } = mission
  const renderHtml = useHtmlRenderer()
  const [t] = useTranslation('common')
  const navigate = useNavigate()

  const getButtons = () => {
    const buttons = [
      { cssClass: 'citizen', callback: () => navigate(ROLE_PUBLIC['citizenSterilizationCall']), text: isCompany ? t('actions.add_citizen_call') : t('labels.make_call') }
    ]

    if (isCompany && !isCoOwnership) {
      buttons.push({ cssClass: 'company', callback: () => navigate(ROLE_PUBLIC['companySterilizationCall']), text: t('actions.add_company_call') })
    }

    if (!isCompany && isCoOwnership) {
      buttons.push({ cssClass: 'coOwnership', callback: () => navigate(ROLE_PUBLIC['companySterilizationCall']), text: t('actions.add_co_ownership_call') })
    }

    if (isCompany && isCoOwnership) {
      buttons.push({ cssClass: 'establishment', callback: () => navigate(ROLE_PUBLIC['companySterilizationCall']), text: t('actions.add_establishment_call') })
    }

    return buttons
  }

  return (
    <Div cssClass='home-page'>
      <Div cssClass='home-text'>
        {renderHtml(homePage.description)}
      </Div>

      <Div cssClass='home-buttons'>
        <Buttons buttons={getButtons()} />
      </Div>
    </Div>
  )
}

export default Home